export const SEARCH_MYSTERY_TAGS = 'SEARCH_MYSTERY_TAGS';
export const DOWNLOAD_TAGGING_SHEET = 'DOWNLOAD_TAGGING_SHEET';
